function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { StyleSheet, View } from 'react-native';
export class PopoverIndicator extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getComponentStyle", source => {
      const flatStyle = StyleSheet.flatten(source);
      return {
        container: {
          // @ts-ignore: `width` is restricted to be a number
          borderLeftWidth: flatStyle.width,
          // @ts-ignore: `width` is restricted to be a number
          borderRightWidth: flatStyle.width,
          // @ts-ignore: `height` is restricted to be a number
          borderBottomWidth: flatStyle.height,
          borderBottomColor: flatStyle.backgroundColor,
          borderLeftColor: 'transparent',
          borderRightColor: 'transparent',
          backgroundColor: 'transparent'
        }
      };
    });
  }

  render() {
    const _this$props = this.props,
          {
      style
    } = _this$props,
          props = _objectWithoutProperties(_this$props, ["style"]);

    const evaStyle = this.getComponentStyle(style);
    return /*#__PURE__*/React.createElement(View, _extends({}, props, {
      style: [style, styles.container, evaStyle.container]
    }));
  }

}
const styles = StyleSheet.create({
  container: {}
});